import React, { Component } from 'react';
import FacebookLogin from 'react-facebook-login';
import ReactGA from 'react-ga';

import firebase from "../firebase/FirebaseProvider";
import getConfig from '../config';
import { withRouter } from 'react-router';
import './facebook.css';

class FacebookAuthButton extends Component {

  constructor(props) {
    super(props);
    this.isUserEqual = this.isUserEqual.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
  }

  handleStateChange(authResponse) {
    const authResponseString = JSON.stringify(authResponse);
    console.log("Auth Response:", authResponseString);
    ReactGA.event({
      category: 'Login',
      action: 'Facebook Login',
      label: authResponseString
    });

    if (authResponse) {
      const self = this;
      var unsubscribe = firebase.auth().onAuthStateChanged(firebaseUser => {
        unsubscribe();
        // [TODO: Fix binding] Proceed with sign-in if a different user was logged in earlier.
        // if (!this.isUserEqual(authResponse, firebaseUser)) {
          var credential = firebase.auth.FacebookAuthProvider.credential(authResponse.accessToken);
          firebase.auth().signInWithCredential(credential)
            .then(user => {
              if(self.props.match.path == '/login') {
                self.props.history.push("/");
              }
            })
            .catch(function (error) {
              console.log("Facebook Auth Error:", error);
              const errorMsg = JSON.stringify(error);
              ReactGA.event({
                category: 'Login',
                action: 'Facebook Login Error',
                label: errorMsg
              });
            });
        //}
      });
    }
  }

  /**
   * Check that the given Facebook user is equals to the given Firebase user. If they are
   * the same, we don't need to re-auth the Firebase connection.
   */
  isUserEqual(facebookAuthResponse, firebaseUser) {
    if (firebaseUser) {
      var providerData = firebaseUser.providerData;
      for (var i = 0; i < providerData.length; i++) {
        if (providerData[i].providerId === firebase.auth.FacebookAuthProvider.PROVIDER_ID &&
          providerData[i].uid === facebookAuthResponse.userID) {
          return true;
        }
      }
    }
    return false;
  }

  render() {
    const config = getConfig();
    return (
      <FacebookLogin
        appId={config.auth.facebook.appId}
        autoLoad={false}
        fields="name,email,picture"
        scope="public_profile"
        callback={this.handleStateChange}
      />
    )
  }
}

export default withRouter(FacebookAuthButton);

